var _path, _path2, _path3, _polyline, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _circle, _circle2, _circle3, _circle4, _ellipse2, _polyline2, _ellipse3, _polyline3, _ellipse4, _polyline4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 280,
    height: 260.84115,
    viewBox: "0 0 785 260.84115",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M803.473,514.24193h-261a1,1,0,0,1,0-2h261a1,1,0,0,1,0,2Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#cacaca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M676.65925,346.33034l-1.71844-21.39163a2.89862,2.89862,0,0,0-4.744-1.1127c-13.79132,3.3836-19.35632,10.58413-20.95038,19.62713a61.78277,61.78277,0,0,0-20.13959-.90646c4.84815-6.90061,4.51386-13.93366-.52923-21.087a2.89868,2.89868,0,0,0-4.72278-1.30539c-9.32831,4.71472-15.853,10.59021-16.90369,18.73239a62.20293,62.20293,0,1,0,69.70807,7.44367Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M684.42568,433.13969c50.415-6.46679,78.77539,75.76709-2.55664,80.34864-4.99023,5.47509-44.10325,10.0534-77.25038,2.49444-29.75242,1.192-63.57489-37.72556-21.86682-90.806Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#3f3d56"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "426.623 156.172 426.623 197.774 446.073 197.774 461.505 155.413",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M703.5738,503.145c-.10693-.15308-.18457-.31421-.27734-.4712q-1.24292.04569-2.48584.09162Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M780.20906,479.10726c-6.209-9.92377-21.40088-12.68116-30.70117-5.57233-4.19678,3.20788-7.0254,7.84534-10.61084,11.72455A39.30647,39.30647,0,0,1,716.067,497.342c-6.09375.91357-12.53907.4176-18.16651,2.92675-5.45752,2.43317-9.5747,9.37922-6.604,14.40506q31.42089-1.15814,62.84131-2.316c6.02637-.22211,12.26709-.49683,17.65576-3.20386C782.254,503.89919,786.418,489.03108,780.20906,479.10726Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M631.56544,450.36156a62.39076,62.39076,0,0,1-25.046-4.99787c-16.525-7.17318-24.09924-19.27835-24.41357-19.79007a.75832.75832,0,0,1,1.292-.79422,55.77511,55.77511,0,0,0,23.80194,19.22614c14.88086,6.43378,40.29272,9.65732,76.84515-11.522a.75835.75835,0,1,1,.76056,1.31222h0C663.34864,446.22862,645.633,450.36156,631.56544,450.36156Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M634.85414,411.87483a5.31415,5.31415,0,0,1-5.30817-5.30816.75831.75831,0,0,1,1.5166,0,3.79154,3.79154,0,0,0,7.58307,0,.75831.75831,0,0,1,1.5166,0A5.31413,5.31413,0,0,1,634.85414,411.87483Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.76035,
    cy: 77.68702,
    rx: 6.06647,
    ry: 2.33326,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M594.44239,397.2589a18.49645,18.49645,0,0,1,28.3913,0,20.55818,20.55818,0,1,0-29.06586-.67456Q594.09724,396.92945,594.44239,397.2589Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M649.94954,397.2589a18.49632,18.49632,0,0,1,28.39123,0,20.55816,20.55816,0,1,0-29.0658-.67462v0h0Q649.60429,396.92946,649.94954,397.2589Z",
    transform: "translate(-207.47297 -319.40078)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 392.15207,
    cy: 64.98755,
    r: 7.0718,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.65717,
    cy: 64.98755,
    r: 7.0718,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.33401,
    cy: 86.62655,
    r: 6.19684,
    fill: "#ff6584"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.33401,
    cy: 86.62655,
    r: 6.19684,
    fill: "#ff6584"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 534.15932,
    cy: 499.4112,
    rx: 5.30817,
    ry: 15.92447,
    transform: "translate(-390.80612 38.79323) rotate(-31.93981)",
    fill: "#3f3d56"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "360.474 142.389 326.686 177.977 335.496 193.148 367.393 174.088",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.28313,
    cy: 525.28637,
    rx: 5.30817,
    ry: 15.92447,
    transform: "matrix(0.14644, -0.98922, 0.98922, 0.14644, -205.33137, 733.65395)",
    fill: "#3f3d56"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "397.024 155.777 402.261 204.569 419.496 208.148 425.659 171.033",
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.97049,
    cy: 521.33625,
    rx: 15.92447,
    ry: 5.30817,
    transform: "translate(-259.59958 -243.24448) rotate(-6.17422)",
    fill: "#3f3d56"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "453.303 155.154 470.666 201.051 488.247 200.172 484.859 162.701",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGato);
export default __webpack_public_path__ + "static/media/gato.71bec70bc6ffae286f75ebcd30915186.svg";
export { ForwardRef as ReactComponent };